import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const styles = (theme) => ({
  formControl: {
    width: "100%",
    "& .MuiInputLabel-root": {
      top: 4,
      textAlign: "center",
      fontFamily: theme.fontFamilyCenturyGothic,
      color: "#000000B2",
    },
    "& .Mui-focused": {
      color: "#b80000",
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#E3E3E3",
      },
      "&:hover fieldset": {
        borderColor: "#E3E3E3",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#b80000",
      },
    },
  },
  icon: {
    color: "#C1C1C1",
    marginRight: "5px",
    cursor: 'pointer'
  },
  menuIte: {
    height: 32,
    marginLeft: -10,
    fontFamily: theme.fontFamilyCenturyGothic,
  },
  checkbox: {
    color: "#b80000",
    "&.Mui-checked": {
      color: "#b80000",
    },
  },
  listItem: {
    "& .MuiTypography-root": {
      fontFamily: theme.fontFamilyCenturyGothic,
      fontSize: "14px"
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "2px",
    marginInline: "5px",
  },

  cancelBtn: {
    fontFamily: `${theme.fontFamilyCenturyGothic} !important`,
    textTransform: "none !important",
    color: "#000000B2 !important",
    fontSize: "12px",
  },
  applyBtn: {
    fontFamily: `${theme.fontFamilyCenturyGothic} !important`,
    textTransform: "none !important",
    color: "#b80000 !important",
    fontSize: "12px",
  },
});

const ITEM_HEIGHT = 48;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5.5,
      width: 200,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  variant: "menu",
};

class MyMultiSelectNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const shouldHide = window.scrollY > 100;
    this.setState({ hidden: shouldHide });
  }
  render() {
    const {
      classes,
      mapId,
      mapName,
      options,
      selectedIds,
      label,
      applyCategory,
      onClose,
      open,
      handleClose,
      handleOpen,
    } = this.props;

    if (this.state.hidden) {
      return null; // Render nothing if hidden
    }
    return (
      <FormControl
        className={classes.formControl}
        variant="outlined"
        size="small"
      >
        <InputLabel id="mutiple-select-label">{this.props.label}</InputLabel>
        <Select
          classes={{
            root: classes.input,
          }}
          multiple
          value={selectedIds}
          onFocus={this.props.onFocus}
          onChange={this.props.handleChange}
          placeholder="Category"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          label={this.props.label}
          // input={<OutlinedInput />}
          error={this.props.error}
          helperText={this.props.helperText}
          renderValue={(data) => {
            var newData = [];
            options &&
              options.map((items) => {
                if (selectedIds.indexOf(items[mapId]) > -1) {
                  newData.push(items[mapName]);
                }
              });
            return newData.join(",");
          }}
          style={{ position: "relative" }}
          MenuProps={MenuProps}
          IconComponent={(props) => (
            <KeyboardArrowDownIcon {...props} className={classes.icon} />
          )}
        >
          {options &&
            options.map((items) => (
              <MenuItem
                className={classes.menuIte}
                key={items[mapId]}
                value={items[mapId]}
              >
                <Checkbox
                  className={classes.checkbox}
                  checked={selectedIds.indexOf(items[mapId]) > -1}
                />
                <ListItemText
                  className={classes.listItem}
                  primary={items[mapName]}
                />
              </MenuItem>
            ))}
          <div className={classes.buttonContainer}>
            <Button variant="text" className={classes.cancelBtn}>
              Cancel
            </Button>
            <Button
              variant="text"
              className={classes.applyBtn}
              onClick={applyCategory}
            >
              Apply
            </Button>
          </div>
        </Select>
      </FormControl>
    );
  }
}

export default withStyles(styles)(MyMultiSelectNews);
